<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div :class="[`col-sm-${size}`, 'control-label', { left: isLeft }]">
    <label
      :for="forID"
      :class="{ required: isRequired, right: isRight }">
      <slot />
    </label>
  </div>
</template>

<script type="text/babel">
  export default {
    props: {
      forID: {
        type: String,
        default: null,
      },
      size: {
        type: [Number, String],
        default: 3,
      },
      isRequired: {
        type: Boolean,
        default: false,
      },
      isRight: {
        type: Boolean,
        default: false,
      },
      isLeft: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .left {
    text-align: left !important;
  }

  label {
    svg {
      height: 2.4rem;
      position: relative;
      top: -0.4rem;
    }
  }
</style>
